module.exports = __webpack_public_path__ + "static/media/new-project.168030c7.svg";